import React, { useEffect, useState } from 'react';
import { ArrowUp } from 'lucide-react';

/**
 * Sits above the chat launcher in the bottom-right stack rather than under it.
 */
export function ScrollToTop() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const toggleVisibility = () => setIsVisible(window.scrollY > 400);
    toggleVisibility();
    window.addEventListener('scroll', toggleVisibility, { passive: true });
    return () => window.removeEventListener('scroll', toggleVisibility);
  }, []);

  return (
    <button
      type="button"
      onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
      aria-label="Back to top"
      className={`fixed left-5 bottom-5 z-[999999] grid h-10 w-10 place-items-center rounded-sm border border-rule bg-background/90 text-muted-foreground backdrop-blur transition-all duration-300 hover:border-signal hover:text-signal ${
        isVisible ? 'translate-y-0 opacity-100' : 'pointer-events-none translate-y-2 opacity-0'
      }`}
    >
      <ArrowUp className="h-4 w-4" />
    </button>
  );
}
